<template>
  <div>
    <PermissionTree :tree="permissionTree"
      :key="permissionTreeKey"
      @update="onPermissionTreeUpdate" />
  </div>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep'
import _debounce from 'lodash/debounce'
import StoreMixin from './storeMixin'
import { DeepDiff } from 'deep-diff'
import Guid from '../../components/Guid'
import PermissionTree from '../company/PermissionTree.vue'
import { CompanySettingService } from '../../services'

export default {
  name: 'CompanyPermissionRecordsSetting',
  components: {
    PermissionTree
  },
  mixins: [StoreMixin],
  props: {
    selectedModuleIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isNew: false,
      companyPermissionRecords: {},
      permissionTreeKey: 0,
      originPermissionRecords: {}
    }
  },
  computed: {
    permissionTree() {
      if (!Array.isArray(this.companyPermissionRecords)) return []
      const map = {}
      const roots = []
      this.companyPermissionRecords.forEach((rec) => {
        map[rec.permissionRecordID] = { ...rec, children: [], isSelected: typeof rec.isSelected === 'boolean' ? rec.isSelected : false }
      })
      this.companyPermissionRecords.forEach((rec) => {
        if (rec.level === 0) {
          roots.push(map[rec.permissionRecordID])
        } else if ((rec.level === 1 || rec.level === 2) && map[rec.parentId]) {
          map[rec.parentId].children.push(map[rec.permissionRecordID])
        }
      })
      return _cloneDeep(roots)
    }
  },
  watch: {
    companyPermissionRecords: {
      handler: function (val) {
        // this.saveSnapshot({ entity: _cloneDeep(val) })
        if (typeof this.autoUpdate === 'function') this.autoUpdate(val)
      },
      deep: true
    }
  },
  async created() {
    this.$showSpinner()
    if (this.$route.params.companyId === 'new') {
      this.isNew = true
    }
    if (!this.$userInfo.isSystemAccount) return

    const newCompany = this.$store.getters['companysetting/newCompany']
    if (this.$userInfo.isSystemAdministrator && !this.$userInfo.isSupportUser) {
      if (newCompany && newCompany.companyPermissionRecords) {
        this.companyPermissionRecords = _cloneDeep(newCompany.companyPermissionRecords)
      } else {
        this.getItems(this.selectedModuleIds)
      }
    }
    this.initializeAutoUpdate()
    this.$hideSpinner()
  },
  methods: {
    hasDiff() {
      return !!DeepDiff.diff(this.originPermissionRecords, this.companyPermissionRecords)
    },
    disableAutoUpdate() {
      if (typeof this.autoUpdate === 'function' && typeof this.autoUpdate.cancel === 'function') {
        this.autoUpdate.cancel()
      }
      this.autoUpdate = () => {}
    },
    initializeAutoUpdate() {
      this.autoUpdate = _debounce(async (value) => {
        this.hasDiff() && (await this.updateCompanyPermissionRecords(value))
      }, this.debounceDelay)
    },
    async updateCompanyPermissionRecords(companyPermissionRecords) {
      if (!this.$userInfo.isSystemAdministrator && !this.$userInfo.isSupportUser) return
      if (!this.hasDiff()) return

      // for (let item of companyPermissionRecords) {
      //   const [baseItem] = this.baseSnapshot.filter((i) => i.flexiQuoteModuleId == item.flexiQuoteModuleId)
      //   const diff = DeepDiff.diff(baseItem, item)
      //   item.deepDiff = diff ? JSON.stringify(diff) : null
      // }
      // this.companyPermissionRecords = _cloneDeep(
      //   await this.editStoreItem({
      //     serviceFunction: 'updateCompanyPermissionRecords',
      //     entity: companyPermissionRecords,
      //     params: this.$route.params.companyId
      //   })
      // )

      this.updateSavingStatus(true)
      await CompanySettingService.updateCompanyPermissionRecords(companyPermissionRecords, this.$route.params.companyId).then((res) => {
        this.companyPermissionRecords = res
        this.updateSavingStatus(false)
      })

      this.originPermissionRecords = _cloneDeep(this.companyPermissionRecords)
      if (this.toastNotificationEnabled) {
        this.openToastNotification()
      }
    },
    async getItems(selectedModuleIds) {
      if (selectedModuleIds) {
        this.$showSpinner()
        // this.companyPermissionRecords = _cloneDeep(
        //   await this.getStoreItem({
        //     serviceFunction: 'getCompanyPermissionRecords',
        //     params: { companyId: this.isNew ? Guid.empty() : this.$route.params.companyId, selectedModuleIds }
        //   })
        // )
        var params = { companyId: this.isNew ? Guid.empty() : this.$route.params.companyId, selectedModuleIds }
        this.companyPermissionRecords = await CompanySettingService.getCompanyPermissionRecords(params)
        this.originPermissionRecords = _cloneDeep(this.companyPermissionRecords)

        this.permissionTreeKey++
        this.$hideSpinner()
      }
    },
    onPermissionTreeUpdate(newTree) {
      function flatten(nodes) {
        let result = []
        nodes.forEach((node) => {
          const { children, ...rest } = node
          result.push(rest)
          if (children && children.length) {
            result = result.concat(flatten(children))
          }
        })
        return result
      }
      const result = flatten(newTree)
      if (JSON.stringify(result) !== JSON.stringify(this.companyPermissionRecords)) {
        this.companyPermissionRecords = result
      }
    }
  },
  async beforeRouteLeave(to, from, next) {
    this.disableAutoUpdate()
    this.toastNotificationEnabled = true
    await this.updateCompanyPermissionRecords(this.companyPermissionRecords)
    // this.clearSnapshots()
    this.toastNotificationEnabled = false
    next()
  }
}
</script>